import React, { useMemo } from 'react';

import GoogleDFP from 'components/GoogleDFP';
import type { UserEntitlements, UserSettings } from 'types/user';
import loadAdConfig from 'utils/adConfig';

import styles from './SpotPageMiddleAd.module.scss';

interface Props {
  entitlements: UserEntitlements;
  spotMiddleAdTarget: [string, string][];
  userSettings: UserSettings | null;
}

const SpotPageMiddleAd: React.FC<Props> = ({ entitlements, spotMiddleAdTarget, userSettings }) => {
  const adConfig = useMemo(
    () => loadAdConfig('spotMiddle', spotMiddleAdTarget, entitlements, !!userSettings, null),
    [entitlements, spotMiddleAdTarget, userSettings],
  );

  return (
    <div className={styles.middleAd} data-testid="middle-ad">
      <GoogleDFP adConfig={adConfig} />
    </div>
  );
};

export default SpotPageMiddleAd;
